import React from 'react';
import ScoringLoader from '../ScoringLoader/ScoringLoader';

/**
 * Компонент контента модального окна прескоринга на стадии Process
 * (скоринг в процессе, контакты отправлены)
 */
export default function StageProcess() {
    return (
        <ScoringLoader title="Расчет лимита" />
    );
}